import { render, staticRenderFns } from "./convention-detail.vue?vue&type=template&id=1a432aa3&scoped=true"
import script from "./convention-detail.vue?vue&type=script&lang=js"
export * from "./convention-detail.vue?vue&type=script&lang=js"
import style0 from "./convention-detail.vue?vue&type=style&index=0&id=1a432aa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a432aa3",
  null
  
)

export default component.exports